import React from 'react'
import { Box, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const CartDrawerHeader = ({ cartQuantity, classes, closeCartDrawer }) => {
    return (
        <Box className={classes.cartHeaderContainer}>
            <div>
                Your cart{' '}
                {cartQuantity > 0 && (
                    <>
                        ({cartQuantity} Item
                        {cartQuantity > 1 && <>s</>})
                    </>
                )}
            </div>
            <IconButton
                className={classes.cartDrawerHeaderCloseButton}
                edge="end"
                aria-label="Close cart drawer"
                component="span"
                onClick={closeCartDrawer}
                disableRipple
            >
                <CloseIcon fontSize={'large'} />
            </IconButton>
        </Box>
    )
}

export default CartDrawerHeader
